import ThirdPartyCollectionDetailPage from './ThirdPartyCollectionDetailPage.container'

export default ThirdPartyCollectionDetailPage
